import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../services/api/consumer.service";
import { ConsumerAdminService } from "../../services/api/consumer-admin.service";
import { ConsumerAchActions } from "../actions/consumer-ach.actions";
import { FailState } from "../models/fail-state";

@Injectable()
export class ConsumerAchEffects {
	fundRequested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAchActions.fundRequested),
			switchMap((action) => {
				return this.consumerAdminService.fundAch(action.achFundingRequest).pipe(
					map(() => ConsumerAchActions.funded()),
					catchError((error) => of(ConsumerAchActions.fundFailed(new FailState(error))))
				);
			})
		)
	);

	accountRetryRequested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAchActions.accountRetryRequested),
			switchMap((action) =>
				this.consumerService.achAccountRetry(action.request).pipe(
					map(() => ConsumerAchActions.accountRetrySucceeded()),
					catchError((error) =>
						of(ConsumerAchActions.accountRetryFailed(new FailState(error)))
					)
				)
			)
		)
	);

	documentRetryRequested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAchActions.documentRetryRequested),
			switchMap((action) =>
				this.consumerService
					.achAccountRetryDocument(action.doc, action.docType, action.benOwnerId)
					.pipe(
						map(() => ConsumerAchActions.documentRetrySucceeded()),
						catchError((error) =>
							of(ConsumerAchActions.documentRetryFailed(new FailState(error)))
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService,
		private consumerAdminService: ConsumerAdminService
	) {}
}
